import { isNil } from 'es-toolkit';

import type { Nullable } from '@clearverify/types';

import { SortOrder } from 'src/api';

export type TableSortDirection = 'asc' | 'desc' | null | undefined;

export const convertGridSortOrder = (sortDirection: TableSortDirection): Nullable<SortOrder> => {
  if (isNil(sortDirection)) return sortDirection;
  return sortDirection === 'asc' ? SortOrder.Asc : SortOrder.Desc;
};
